<template>
  <div>
      <section class="allP newsEvent">      
         <div class="content wp1200 paddingRight">
            <ul>
                <li class="flex">
                    <span class="icon absolute warpit_icon_calendar"></span>
                    <div class="titleAndDesc">
                        <h3>Fokusna skupina</h3>
                        <a href="#" class="boxesLink"><h2><span>Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
                    <ul>
                        <li><span class="icon warpit_icon_pointer"></span><span>Ljubljana</span></li>
                        <li><span class="icon warpit_icon_calendar"></span><span>12.12.2021 12:30</span></li>
                    </ul>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_calendar"></span>
                    <div class="titleAndDesc">
                        <h3>Ples</h3>
                        <a href="#" class="boxesLink"><h2><span>Maskenball za nabirko za društvo proti mučenju živali</span></h2></a>
                    </div>
                    <ul>
                        <li><span class="icon warpit_icon_pointer"></span><span>Ljubljana</span></li>
                        <li><span class="icon warpit_icon_calendar"></span><span>12.12.2021 12:30</span></li>
                    </ul>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_calendar"></span>
                    <div class="titleAndDesc">
                        <h3>Fokusna skupina</h3>
                        <a href="#" class="boxesLink"><h2><span>Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
                    <ul>
                        <li><span class="icon warpit_icon_pointer"></span><span>Ljubljana</span></li>
                        <li><span class="icon warpit_icon_calendar"></span><span>12.12.2021 12:30</span></li>
                    </ul>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_news"></span>
                    <div class="titleAndDesc">
                        <a href="#" class="boxesLink"><h2><span>Rezultati nagradnega žrebanja za anketo  Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_news"></span>
                    <div class="titleAndDesc">
                        <a href="#" class="boxesLink"><h2><span>Rezultati nagradnega žrebanja za anketo  Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
         
         <img src="@/assets/images/frame.jpg"/>

                </li>
                <li class="flex">
                    <span class="icon absolute warpit_icon_news"></span>
                    <div class="titleAndDesc">
                        <a href="#" class="boxesLink"><h2><span>Rezultati nagradnega žrebanja za anketo  Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_calendar"></span>
                    <div class="titleAndDesc">
                        <h3>Ples</h3>
                        <a href="#" class="boxesLink"><h2><span>Maskenball za nabirko za društvo proti mučenju živali</span></h2></a>
                    </div>
                    <ul>
                        <li><span class="icon warpit_icon_pointer"></span><span>Ljubljana</span></li>
                        <li><span class="icon warpit_icon_calendar"></span><span>12.12.2021 12:30</span></li>
                    </ul>
                </li>

                <li class="flex">
                    <span class="icon absolute warpit_icon_calendar"></span>
                    <div class="titleAndDesc">
                        <h3>Fokusna skupina</h3>
                        <a href="#" class="boxesLink"><h2><span>Zadovoljstvo z javnim prometom v Ljubljani</span></h2></a>
                    </div>
                    <ul>
                        <li><span class="icon warpit_icon_pointer"></span><span>Ljubljana</span></li>
                        <li><span class="icon warpit_icon_calendar"></span><span>12.12.2021 12:30</span></li>
                    </ul>
                </li>
            </ul>
        </div>
      </section>        
  </div>
</template>
<script>
export default {
  data() {
    return {

      notCompleted: true,
    };
  },
  computed: {

  },
  components: {},
  mounted() {},
  methods: {

  },
};
</script>
<style>
.newsEvent ul li .titleAndDesc h2 {
    font-size: 18px !important;
    line-height: 22px !important;
    color: #0297A7 !important;
}
</style>